<script setup>
import { ref, nextTick, computed, onMounted } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import TagMultiSelectComboBox from 'dashboard/components-next/combobox/TagMultiSelectComboBox.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const channelId = ref('');
const selectedAgentIds = ref([]);
const notification = ref('');

const getters = useStoreGetters();
const agents = computed(() => getters['agents/getAgents'].value);

const agentMenuItems = computed(() =>
  agents.value.map(a => ({ value: a.id, label: a.name }))
);

function updateValue() {
  emit('update:modelValue', {
    channel_id: channelId.value,
    selected_agents: selectedAgentIds.value,
    notification: notification.value,
  });
}

onMounted(async () => {
  channelId.value = props.modelValue.channel_id || '';
  notification.value = props.modelValue.notification || '';
  selectedAgentIds.value = props.modelValue.selected_agents || [];

  await nextTick();
  updateValue();
});
</script>

<template>
  <div class="mt-2 mr-1">
    <div class="flex justify-between items-center full-width gap-4">
      <input
        v-model="channelId"
        type="text"
        class="answer--text-input"
        :placeholder="$t('AUTOMATION.ACTION.SLACK_CHANNEL_INPUT_PLACEHOLDER')"
        @update:model-value="updateValue"
      />
      <TagMultiSelectComboBox
        v-model="selectedAgentIds"
        :options="agentMenuItems"
        :placeholder="$t('FORMS.MULTISELECT.SELECT')"
        @update:model-value="updateValue"
      />
    </div>
    <WootMessageEditor
      v-model="notification"
      rows="4"
      enable-variables
      :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
      class="action-message"
      @update:model-value="updateValue"
    />
  </div>
</template>

<style lang="scss" scoped>
.action-message {
  @apply mt-2 mx-0 mb-0 min-h-[5rem];
}
// Prosemirror does not have a native way of hiding the menu bar, hence
:deep(.ProseMirror-menubar) {
  @apply hidden;
}
</style>
